// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".salesclerk-add .form .tips[data-v-5472333d]{margin:30px 0;font-size:12px;color:silver}", ""]);
// Exports
module.exports = exports;
